export class AdminApiError extends Error {
    constructor(status, code) {
        super(code);
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
        this.name = 'AdminApiError';
    }
}
export const adminRequest = async (path, options = {}) => {
    const response = await fetch(path, {
        ...options,
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
            Accept: 'application/json',
            ...(options.body === undefined ? {} : { 'Content-Type': 'application/json' }),
            ...options.headers
        }
    });
    let payload = null;
    try {
        payload = await response.json();
    }
    catch {
        throw new AdminApiError(response.status || 503, 'service_unavailable');
    }
    if (!response.ok || !payload || typeof payload !== 'object') {
        const code = payload && typeof payload === 'object' && 'error' in payload
            ? String(payload.error)
            : 'service_unavailable';
        throw new AdminApiError(response.status, code);
    }
    return payload;
};
const request = adminRequest;
export const adminAuth = {
    login: (identifier, password) => request('/api/admin/auth/login.php', {
        method: 'POST',
        body: JSON.stringify({ identifier, password })
    }),
    verifyTotp: (totp) => request('/api/admin/auth/verify-totp.php', {
        method: 'POST',
        body: JSON.stringify({ totp })
    }),
    useRecoveryCode: (recoveryCode) => request('/api/admin/auth/use-recovery-code.php', {
        method: 'POST',
        body: JSON.stringify({ recoveryCode })
    }),
    me: () => request('/api/admin/auth/me.php'),
    csrf: () => request('/api/admin/auth/csrf.php'),
    logout: async () => {
        const { csrfToken } = await adminAuth.csrf();
        return request('/api/admin/auth/logout.php', {
            method: 'POST',
            headers: { 'X-CSRF-Token': csrfToken },
            body: JSON.stringify({})
        });
    }
};
